import React, { useState } from 'react';
import styles from './ContactDeleteModal.module.css';
import { Button, ButtonVariant, Label, useModal, useToast } from '@fs/uikit-react';
import { Contact } from '@/shared/model/contact.ts';
import { ContactApi } from '@/pages/Operator/Person/api/ContactApi.ts';
import { getUserFriendlyErrorMessage } from '@/utils/errorHandling.ts';
import { ApiError } from '@/services/api';

interface ContactDeleteModalProps {
  contact: Contact;
  onSuccess: () => void;
}

const ContactDeleteModal: React.FC<ContactDeleteModalProps> = ({ contact, onSuccess }) => {
  const { closeModal } = useModal();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    if (!contact.id) return;
    setIsLoading(true);
    try {
      await ContactApi.delete(contact.id);
      toast.showSuccessToast('Успішно', 'Контакт видалено');
      closeModal();
      onSuccess();
    } catch (error) {
      console.error('Error deleting contact:', error);
      toast.showErrorToast('Помилка видалення', getUserFriendlyErrorMessage(error as ApiError));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.modalContent}>
      <Label text={'Ви впевнені, що хочете видалити цей контакт?'} />
      <div className={styles.buttonGroup}>
        <Button title={isLoading ? 'Видалення...' : 'Видалити'} onClick={handleDelete} loading={isLoading} variant={ButtonVariant.DESTRUCTIVE} />
        <Button title="Скасувати" onClick={closeModal} variant={ButtonVariant.SECONDARY} />
      </div>
    </div>
  );
};

export default ContactDeleteModal;
